import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, RouterModule, Routes } from '@angular/router';
import { ErpKeycloakService } from '@shared/services/erp-keycloak/erp-keycloak.service';
import { TooltipModule } from 'primeng/tooltip';
import { ErpSidebarItemComponent } from '../erp-sidebar-item/erp-sidebar-item.component';

@Component({
  selector: 'erp-sidebar',
  imports: [RouterModule, TooltipModule, ErpSidebarItemComponent],
  templateUrl: './erp-sidebar.component.html',
  styleUrl: './erp-sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErpSidebarComponent {
  private readonly keycloak: ErpKeycloakService = inject(ErpKeycloakService)
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute)
  public rotas?: Routes = this.activatedRoute.routeConfig?.children
  public logout = () => this.keycloak.logout()
}